import { Stack } from '@mui/material';
import ListOfAccounts from '../../components/Accounts/ListOfAccounts';
import VegaPageHeader from '../../components/common/VegaPageHeader';
import VegaText from '../../components/common/VegaText';
import VegaButton from '../../components/common/VegaButton';
import { useAppDispatch, useAppSelector } from '../../store';
import { getAccountList, getAccountState } from '../../features/accountsSlice';
import { CreateVisits } from '../../types/minVisitsType';
import { MinVisitsSevices } from '../../Apis/MinVisitsServices';
import { useSnackbar } from '../../providers/SnackbarProvider';
import { getErrorMessageFromErrorObj } from '../../utils/api';
import { LoanListRequest } from '../../types/request/loan';
import { useClientAuth } from '../../providers/ClientProvider';

const Accounts = () => {
  const { selectedRows } = useAppSelector(getAccountState);
  const { userId } = useClientAuth();
  const { setSnackbar } = useSnackbar();
  const dispatch = useAppDispatch();

  const onMoveToTodayClick = () => {
    const visits = selectedRows.map(
      (loanId: string) =>
        ({
          agentId: userId,
          loanId,
          location: {
            latitude: 123.0,
            longitude: 123.0,
          },
        } as CreateVisits)
    );
    MinVisitsSevices.createMinVisitBulk({ visits })
      .then(() => {
        setSnackbar('Move to today Successfully !!!');
        const body = {
          includeLmsVariables: true,
          includeCustomerDetails: true,
          page: 0,
          pageSize: 10,
        } as LoanListRequest;
        dispatch(getAccountList(body));
      })
      .catch(error => {
        setSnackbar(getErrorMessageFromErrorObj(error), 'error');
      });
  };
  return (
    <>
      <VegaPageHeader
        renderLeftView={() => {
          return (
            <Stack spacing={'2rem'}>
              <VegaText
                text={'Receipt Management'}
                fontWeight={600}
                fontSize={'1.0625rem'}
                color={'black'}
              />
            </Stack>
          );
        }}
        renderRightView={() => {
          return (
            <VegaButton
              text="Move To Today"
              onClick={onMoveToTodayClick}
              disabled={!selectedRows.length}
            />
          );
        }}
      />
      <ListOfAccounts />
    </>
  );
};

export default Accounts;
